<template>

  <v-container fluid fill-height pa-0>

    <v-layout column fill-height ma-0 pa-0>

      <v-layout fill-height column  ma-0 pt-0 px-2>
        
        <scroll-area>

          <template slot="header">

            <v-layout column justify-start>

              <v-layout style="height: 40px" mb-0 mt-2 px-0>
                <v-layout fill-height class="title toolbar_castom" style="background-color: #D4EEFC">
                  <v-layout align-center justify-start px-2>
                    <span class="uppercase body-2">{{ $t('sertificates') }}</span>
                  </v-layout>
                </v-layout>
              </v-layout>

              <v-layout style="height: 60px" mb-2 mt-2 px-0>
                <v-layout column fill-height class="title toolbar_castom" style="background-color: #F9F9FB">
                  <v-layout align-center justify-start px-2>
                    <span class="body-2">{{ $t('Центр сертификации (CA)') }}</span>
                  </v-layout>
                  <v-layout align-start justify-start px-2>
                    <span class="caption secondary--text">{{ $t('Управление корневым сертификатом системы') }}</span>
                  </v-layout>
                </v-layout>
              </v-layout>

              <v-tabs
                light     
                v-model="panel"
                height="40px"
                left
              >
                <v-tabs-slider color="primary" style="height: 0px; max-width: 0px"></v-tabs-slider>
                <v-tab
                    class="font-weight-normal"    
                    v-for="(place, index) in getPlaces"
                    :key="index"
                  >
                  <template slot="default">
                    <div class="tab_wrapper">
                      <div :class="getPlaces[panel] == place ? 'tab__border' : 'custom-tab'">
                        {{ $t(place) }} 
                      </div>
                    </div>
                  </template>
                </v-tab>
              </v-tabs>

            </v-layout>

          </template>
          
          <template slot="body">

            <v-layout column v-if="getPlaces[panel] == 'sertificate CA'" fill-height justify-start ma-0 px-1 pt-2>
              <ca/>
            </v-layout>
            <v-layout column v-if="getPlaces[panel] == 'reissue CA'" fill-height justify-start ma-0 px-1 pt-2>
              <reissue/>
            </v-layout>
            <v-layout column v-if="getPlaces[panel] == 'import ca (p12)'" fill-height justify-start ma-0 px-1 pt-2>
              <c-import/>
            </v-layout>

          </template>

        </scroll-area>

      </v-layout>

    </v-layout>

  </v-container>

</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import scrollTable from '@/nms/components/partials/scrolltable.vue'
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue'
import ca from '@/nms/pages/configuration/components/sertificates-ca.vue'
import reissue from '@/nms/pages/configuration/components/sertificates-reissue.vue'
import CImport from '@/nms/pages/configuration/components/sertificates-import.vue'
import { $_localhost } from '@/nms/plugins/bridge.js'

// Типы
interface CertificateData {
  cn: string | null
  o: string | null
  c: string | null
  st: string | null
  l: string | null
  ou: string | null
}

interface ModelData {
  obj: CertificateData
  fields: Record<string, any>
}

interface FileItem {
  id?: string
  name?: string
  [key: string]: any
}

interface ItemsResponse {
  items?: FileItem[]
  [key: string]: any
}

interface CurrentState {
  files: any[]
  update: string[]
}

export default Vue.extend({
  name: 'SERTIFICATES',

  components: {
    scrollArea,
    scrollTable,
    svgIcon,
    ca,
    reissue,
    CImport
  },

  props: {},

  data(): {
    panel: number
    places: string[]
    clear: boolean
    selectedCrt: FileItem | null
    crt: FileItem[]
    meta: any | null
    data: any | null
    model: ModelData
    current: CurrentState
  } {
    return {
      panel: 0,
      places: ['sertificate CA', 'reissue CA', 'import ca (p12)'],
      clear: false,
      selectedCrt: null,
      crt: [],
      meta: null,
      data: null,
      model: {
        obj: {
          cn: null,
          o: null,
          c: null,
          st: null,
          l: null,
          ou: null,
        },
        fields: {}
      },
      current: {
        files: [],
        update: []
      },
    }
  },

  computed: {
    getData(): any | null {
      return this.data
    },

    getObj(): CertificateData {
      return this.model.obj
    },

    getFields(): Record<string, any> {
      return this.model.fields
    },

    getPlaces(): string[] {
      return this.places
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    async setup(): Promise<void> {
      await this.loadCrt()
    },

    async loadCrt(): Promise<void> {
      try {
        const items_ = await this.$bridge.customQuery('scripter', 'filemanager/files/Lw/children', { data: { orderBy: 'name', orderDirection: 'ASC' } }, 'GET') as FileItem[] | ItemsResponse

        let items: FileItem[] = []
        if (Array.isArray(items_)) {
          items = items_
        } else if (items_?.items && Array.isArray(items_.items)) {
          items = items_.items
        }

        const pgBackUpFiles = items.find(el => el.name === 'certificates')
        if (pgBackUpFiles) {
          const data = await this.$bridge.customQuery('scripter', `filemanager/files/${pgBackUpFiles.id}/children`, { data: { orderBy: 'name', orderDirection: 'ASC' } }, 'GET') as ItemsResponse
          if (data?.items && Array.isArray(data.items)) {
            this.crt = data.items
          }
        }
      } catch (error) {
        console.error(this.$options.name, 'loadCrt smth wrong', error)
      }
    },

    reset(): void {
      this.model = {
        obj: {
          cn: null,
          o: null,
          c: null,
          st: null,
          l: null,
          ou: null,
        },
        fields: {}
      }
    },
  },
})
</script>

<style lang="css" scoped>
.toolbar_castom {
    border: solid 1px #9F9F9F ;
    border-radius: 2px;
    /* background-color: #D4EEFC */
  }
</style>

<style lang="stylus" scoped>

    .button-file-upload

        position: relative
        box-sizing: border-box

        &_extension

            &_blank

                padding-left: 0;
                border-color: transparent

            &_new

                padding-left: 0;
                border-color: transparent

        &__area

            display: flex
            justify-content: center

            width: 80px
            height: 80px

            border-radius: 50%
            border: 1px solid alpha(#000, .4)

        &__control

            position: relative
            overflow: hidden
            z-index: 2

            cursor: pointer

            &.fiv-icon-blank

                opacity: .4
                transition: opacity .4s

                &:hover

                    opacity: 1

            &.fiv-icon-new

                opacity: .4
                transition: opacity .4s

                &:hover

                    opacity: 1

        &__overlay

            position: absolute

            top: 0
            right: 0
            bottom: 0
            left: 0

            margin-right: -8px

            width: 100%
            /* height */

            background: alpha(#fff, .9)

            opacity: 0
            transition: opacity .4s

            &:hover

                opacity: 1

        &__delete

            cursor: pointer

            margin-right: -16px
            margin-top: -16px

            opacity: .5
            transition: opacity .4s

            &:hover

                opacity: 1

        &__input

            display: block
            position: absolute

            top: 0
            right: 0

            width: 100%
            height: 100%
            /* min-width: 100%
            min-height: 100% */

            text-align: right

            opacity: 0
            outline: none
            cursor: inherit

        &__name

            display: block /* Fallback for non-webkit */
            max-height: calc(20px * 2) /* Fallback for non-webkit */
            min-height: calc(20px * 2) /* Fallback for non-webkit */
            margin: 0 auto
            font-size: 12px
            line-height: 16px
            -webkit-line-clamp: 3
            -webkit-box-orient: vertical
            overflow: hidden
            text-overflow: ellipsis
            word-break: break-all
            text-align: center;


</style>
